import styled from 'styled-components';
import PropTypes from 'prop-types';

const MainContainer = styled.div`
    margin-bottom: 0.5em;
`;
const OptionContainer = styled.div``;

const GroupLabel = styled.div``;
const Label = styled.label.attrs(
    (props) =>
        props.width && {
            style: { width: props.width, display: 'inline-block' },
        }
)`
    ${(props) => props.disabled && `color: rgb(170,170,170);`}
`;

const Input = styled.input.attrs((props) => {
    const attrs = {
        type: 'radio',
    };
    if (props.width) {
        attrs.style = { width: props.width, display: 'inline-block' };
    }
    return attrs;
})``;

const RadioGroup = ({
    label,
    options = [],
    value,
    onChange,
    id,
    disabled,
    className,
    style,
}) => {
    const handleChange = (ev) => {
        const inputValue = ev.target.value;
        onChange(inputValue);
    };

    return (
        <MainContainer className={className} style={style}>
            {label && <GroupLabel>{label}</GroupLabel>}
            {options.map((option, i) => {
                const inputId = `${id || 'radio-group'}-${option.value}`;
                return (
                    <OptionContainer key={inputId}>
                        <Input
                            checked={option.value === value}
                            value={option.value}
                            onChange={handleChange}
                            id={inputId}
                            disabled={disabled}
                        />

                        <Label htmlFor={inputId} disabled={disabled}>
                            {option.label}
                        </Label>
                    </OptionContainer>
                );
            })}
        </MainContainer>
    );
};

RadioGroup.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.node,
        })
    ),
    label: PropTypes.node,
    value: PropTypes.any,
    onChange: PropTypes.func, // function(value){}
    labelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    inputWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default RadioGroup;
